/**
 * Component names in the catalogue are multi-line, e.g.
 * "BASIC M & E FITTINGS\n\nPLUMBING FITTINGS\n(GULLY AND FLOOR TRAP)".
 * Split them into a short title plus optional group and detail lines so
 * phones show a readable option instead of one long block of text.
 *
 * @param {string} name
 * @returns {{ group: string|null, title: string, detail: string|null }}
 */
export default function componentName(name) {
    const lines = String(name || '')
        .split(/\r?\n/)
        .map(line => line.trim())
        .filter(Boolean);

    if (lines.length === 0) {
        return { group: null, title: '', detail: null };
    }

    if (lines.length >= 2 && !lines[1].startsWith('(')) {
        return {
            group: lines[0],
            title: lines[1],
            detail: lines.slice(2).join(' ') || null,
        };
    }

    return {
        group: null,
        title: lines[0],
        detail: lines.slice(1).join(' ') || null,
    };
}
